import React from 'react';
import { useEffect, useState } from "react";
import _ from "lodash";
import { Icon } from "semantic-ui-react";
import { openLink } from "../utils/helpers";
import Frame from "react-frame-component";
import SizeSelector from "../utils/size-selector";
import Loading from "../../app/loading";

const StageBanner = ({ banner, selectors }) => {
  const [fields, setFields] = useState({});
  const [leftStyles, setLeftStyles] = useState({});
  const [boxStyles, setBoxStyles] = useState({});
  const [ctaStyles, setCtaStyles] = useState({});
  const [hover, setHover] = useState(false);
  const [ctaHoverStyle, setCtaHoverStyle] = useState("none");
  const [totalFileSize, setTotalFileSize] = useState();

  useEffect(() => {
    if (banner.fields) setFields(banner.fields);
  }, [banner]);

  useEffect(() => {
    if (!_.isEmpty(fields)) {
      setLeftStyles({
        backgroundImage: `url("${fields.MainBackgroundImage.path}")`,
        backgroundPositionX: `${fields.MainBackgroundPosition}`,
        backgroundPositionY: `${fields.MainBackgroundVertical}`,
        backgroundColor: fields.MainBackgroundColour,
        backgroundSize: fields.MainBackgroundSize,
      });
      setBoxStyles({
        backgroundImage: `url("${fields.ExtraBackgroundImage.path}")`,
        backgroundSize: fields.ExtraBackgroundSize,
        backgroundPositionX: fields.ExtraBackgroundPositionFromLeft,
        backgroundPositionY: fields.ExtraBackgroundPositionFromTop,
      });
      setCtaStyles({
        backgroundColor: `rgb(${fields.CTAColour})`,
        backgroundImage: `url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2058%2058%22%3E%3Cpath%20fill%3D%22%23${fields.CTAArrowColour}%22%20d%3D%22M19.917%2015.84a1.352%201.352%200%200%200%200%201.92L31.26%2029.005%2019.917%2040.248a1.356%201.356%200%200%200%200%201.924l1.457%201.44c.534.532%201.41.532%201.943%200l13.785-13.646a1.356%201.356%200%200%200%200-1.924L23.317%2014.396a1.39%201.39%200%200%200-1.943%200l-1.457%201.444z%22%2F%3E%3C%2Fsvg%3E)`,
        boxShadow: ctaHoverStyle,
      });
    }
  }, [fields, ctaHoverStyle]);

  useEffect(() => {
    hover
      ? setCtaHoverStyle(`0px 0px 0px 4px rgba(${fields.CTAColour}, 0.4)`)
      : setCtaHoverStyle("none");
  }, [hover, fields]);

  useEffect(() => {
    let total = 0;
    _.forEach(banner.fields, (field, index) => {
      if (field.size && index !== "TabletText") {
        total += field.size;
      }
      setTotalFileSize(Math.round(total / 1000));
    });
  }, [banner.fields]);

  const url = encodeURIComponent(banner.bannerURL);

  if (!selectors || _.isEmpty(fields)) return <Loading />;

  return (
    <SizeSelector selectors={selectors}>
      <Frame
        initialContent={`<!DOCTYPE html><html><head><link
          href="${process.env.PUBLIC_URL}/static/css/hybrid.css?v=3"
          rel="stylesheet"
        /><style>@media(max-width:899px){.value-tile-no .product_2{display:block}}@media(max-width:799px){.content{width: 55%}}@media(max-width:440px){.images{width:90%}.images img.product_2{margin-left:0}}@media(max-width:468px){.value-tile-no .product_2 {display: block}}</style></head><body><div id="bannerFrame"></div></body></html>`}
        mountTarget="#bannerFrame"
        className={`regular-price-`}
      >
        <div
          className="wrapper"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <div
            className={`container value-tile-${
              fields.IncludeValueTile ? "yes" : "no"
            } clubcardprice-${
              fields.AddClubcardPrice ? "yes" : "no"
            } secondpackshot-${
              fields.AddSecondPackshot ? "yes" : "no"
            } regular-price-${
              fields.AddRegularPrice ? "yes" : "no"
            } mobile-text-no products-${fields.ShowPackshots ? "yes" : "no"}`}
          >
            <a href={banner.bannerURL} onClick={(e) => openLink(e, url)}>
              <div className="right">
                <div className="gtb-value-tile">
                  <div className="regular-price">
                    <p
                      className="regular-price-price"
                      style={{ fontSize: "14px" }}
                    >
                      {fields.RegularPrice}
                    </p>
                  </div>
                  <div className="value-tile-top">
                    <p>
                      <span
                        className="value-tile-top-text"
                        style={{
                          fontSize: fields.ValueTileTopFontSize,
                          textDecoration: "none",
                          marginBottom: "4px",
                          marginTop: "0px",
                        }}
                      >
                        {fields.ValueTileTop}
                      </span>
                      <span
                        className="value-tile-bottom-text"
                        style={{
                          marginTop: "0px",
                          fontSize: fields.ValueTileBottomFontSize,
                        }}
                      >
                        {fields.ValueTileBottom}
                      </span>
                    </p>
                  </div>
                  <div className="value-tile-divider"></div>
                  <div className="value-tile-bottom">
                    <div className="value-tile-clubcard">Clubcard Price</div>
                  </div>
                </div>
              </div>
              <div className="left" style={leftStyles}>
                <div className="box" style={boxStyles}>
                  <div className="item content">
                    <div
                      className={`logo logo-${fields.AddLogo ? "yes" : "no"}`}
                      style={{ justifyContent: fields.LogoPosition }}
                    >
                      <img
                        src={fields.Logo.path}
                        className="banner--brand-img"
                        alt={fields.LogoDescription}
                      />
                    </div>
                    <div
                      className="text-panel"
                      style={{ textAlign: fields.TextPosition }}
                    >
                      <picture>
                        <source
                          media="(max-width: 800px)"
                          srcSet={`${fields.TabletText.path} 800w`}
                          sizes="800px"
                        />
                        <source
                          media="(min-width: 801px)"
                          srcSet={`${fields.DesktopText.path} 1486w`}
                          sizes="1486px"
                        />
                        <img
                          alt={fields.MainTextDescription}
                          src={fields.DesktopText.path}
                        />
                      </picture>
                    </div>
                  </div>
                  <div className="item images">
                    <img
                      src={fields.MainPackshot.path}
                      className="product_1"
                      alt={fields.MainPackshotDescription}
                    />
                    <img
                      src={fields.SecondPackshot.path}
                      className="product_2"
                      alt={fields.SecondPackshotDescription}
                    />
                  </div>
                  <p
                    className={`drinkaware-${
                      fields.Drinkaware ? "yes" : "no"
                    } ${fields.DrinkawareType}`}
                  >
                    be <strong>drinkaware</strong>.co.uk
                  </p>
                </div>
              </div>
              <div className="cta" style={ctaStyles}></div>
            </a>
          </div>
        </div>
      </Frame>
      <p>
        <em>
          Total file size:{" "}
          <strong>
            {totalFileSize} kb{" "}
            {totalFileSize > 300 ? (
              <Icon name="thumbs down outline" color="red" />
            ) : (
              <Icon name="thumbs up outline" color="green" />
            )}
          </strong>
        </em>
      </p>
    </SizeSelector>
  );
};

export default StageBanner;
